module.exports = __webpack_public_path__ + "img/laspi.434cd76e.png";